import { FlagCode } from '../../components/flag/index';
import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

type PlanProps = {
  enabled?: boolean;
  onError?: (error: HttpException | unknown) => void;
};

export const useCountryCode = ({ enabled, onError }: PlanProps = {}) => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_IP_COUNTRY_CODE);

  const { data: countryCode, isLoading } = useAppQuery<Lowercase<FlagCode>>({
    queryKey: [QueryKey.GET_IP_COUNTRY_CODE],
    queryFn: () => ApiService.get({ endpoint: BackendRoute.IP_INFO, routePath: ['county-code'] }),
    onError,
    enabled,
  });

  return { countryCode, invalidateQuery, isLoading };
};
